import { FolderOpen } from "@mui/icons-material";
import Button from "e.sic-platform.webclient/src/components/button/Button";
import useThemeService from 'e.sic-platform.webclient/src/services/theme-service/ThemeService';

export default function LoadButton(props: {disabled?: boolean, onClick?(): void}) {
  const { themeClass } = useThemeService();

  return (
    <Button
      id="load"
      onClick={props.onClick}
      disabled={props.disabled}
      icon={{
        svg: FolderOpen,
        textKey: "general.load",
        textClass: "actions-header-button-label",
        className: themeClass(["icon-mui"]),
      }}
    />
  );
}
